<div [formGroup]="checkboxGroup" class="checkbox-group">
  <cm-checkbox *ngFor="let option of options" [formControl]="checkboxGroup.controls[option.id]">{{option.name}}</cm-checkbox>
</div>
